import { getPriceFormat } from '@app/shared/helpers';
import { ConfigPrice, ConfigPriceStore, defaultPrice } from '../config';

export function getPriceForRegion(regionId: number): number {
  return ConfigPrice[regionId] || defaultPrice;
}

export function getPriceForStore(storeId: number): number {
  return ConfigPriceStore[storeId];
}

export function getTextProduct() {
  return 'При покупке этого комплекта (4 шт.) доступны дополнительные слоты записи на монтаж';
}

export function getTextBasket(regionId: number): string {
  const price = getPriceFormat(getPriceForRegion(regionId));
  return `После покупки на сумму от ${price} ₽ будут доступны дополнительные слоты записи на монтаж.`;
}

export function getTextMessage(regionId: number): string {
  const price = getPriceFormat(getPriceForRegion(regionId));
  return `При покупке от ${price} руб. возможна приоритетная запись&#160;на&#160;шиномонтаж.`;
}

export function getTextMessageSuccessPage(regionId: number): string {
  const price = getPriceFormat(getPriceForRegion(regionId));
  // eslint-disable-next-line max-len
  return `При покупке от ${price} руб. вам доступна приоритетная запись&#160;на&#160;шиномонтаж. Обратитесь в контакт-центр или запишитесь самостоятельно.`;
}
